module.exports = __webpack_public_path__ + "static/media/Landing Page Banner_Tablet 2x.cca7b26f.webp";